import React from 'react'
import DisconnectedTools from './DisconnectedTools'
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { DisconnectedAttDvce } from '../../services/LoginPageService';
import DisRowClick from './DisRowClick';

const DisconnectedDeviceList = () => {
    const [rows,setRow]=useState([]);
    const [isAddButton, setIsAddButton] = useState(true);
    const [isAdd,setIsAdd] = useState(true);
    const [editSubject, setEditSubject] = useState('');
    const [open, setOpen] = useState(false);
    const [openDis, setOpenDis] = useState(false);
    const [refreshData, setRefreshData] = useState(false);
    const [isLoading, setGridLoading] = useState(true);
    const [deleteId,setDeleteId]=useState('');
    const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
    const [disData,setDisData]= useState("");
    const [openNotification, setNotification] = useState({
        status: false,
        type: 'error',
        message:'',
    });

    useEffect(()=>{
        DisconnectedAttDvce(handleDisconDvceShow,handeDisconDvceException)
    },[refreshData])

    const handleDisconDvceShow=(dataObject)=>{
        setGridLoading(false);
        setRow(dataObject?.data || []);
    }
    
    const handeDisconDvceException=(errorStatus, errorMessage)=>{
        console.log(errorMessage);
    }

    const columns = [
        {
          field: 'deviceId',
          headerClassName: 'super-app-theme--header',
          headerName: 'Device Id',
          minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
        },
        {
          field: 'specialization',
          headerName: 'Specialization',
          headerClassName: 'super-app-theme--header',
          minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
          field: 'semester',
          headerName: 'Year',
          headerClassName: 'super-app-theme--header',
          minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
        {
            field: 'section',
            headerName: 'Section',
            headerClassName: 'super-app-theme--header',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
        },
    ];

    const onDisClick=(props)=>{
        console.log("sucess");
        console.log(props.row);
        setDisData(props.row);
        setOpenDis(true);
      }
    
      const handleClose = () => {
        setNotification({
          status: false,
          type: '',
          message: '',
        });
      };

    return (
        <div style={{ height:520 , width: '98%',marginLeft:'5px' ,marginTop:'10px',overflow: "scroll",marginRight:'10px' }}>
        <DisconnectedTools />

        <DataGrid
        rows={rows}
        columns={columns}
        onRowClick={onDisClick}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
        height: '480px',
        width: '100%',
        '& .super-app-theme--header': {
          WebkitTextStrokeWidth:'0.6px',             
        },
      }}/>
      
      <DisRowClick
        setOpenDis={setOpenDis}
        openDis={openDis}
        disData={disData}
      />
        </div>
    )
}

export default DisconnectedDeviceList
